import React, {useEffect} from "react";
import {Button, Divider, Stack, Typography} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {useNavigate} from "react-router-dom";
import {buttonStyle, sectionPanel, sectionStack, subSectionPanel} from "../../../AppStyles";

const ExtensionTaskablesPane = (props) => {

    const navigate = useNavigate();

    useEffect(() => {

    }, []);

    function onDeploy()
    {
        navigate("../extensions/" + props.extensionUID + "/deploy")
    }

    return (
        <Stack direction="column" spacing={1} padding={1} width="100%" alignItems="flex-start" justifyContent="flex-start"
               sx={sectionPanel}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/deployment_service.png" width={32} height={32}/>
                    <Typography variant="h6">Taskable Deployments</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Button onClick={onDeploy}
                            sx={buttonStyle}
                            startIcon={<AddCircleOutlineIcon />}>ADD</Button>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="column" spacing={1} width="100%" minHeight={100}
                   sx={subSectionPanel}>

            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
    );
}

export default ExtensionTaskablesPane;
